const reportsmge = r => require.ensure([], () => r(require('@/page/reportsmge/reportsmge')), 'reportsmge');
const reportIndex = r => require.ensure([], () => r(require('@/page/reportsmge/reportIndex/reportIndex')), 'reportIndex');



const reportsmgeRouter = {
  path: '',
  component: reportsmge,
  meta: {
    icon: 'organMge',
    right: [],
    isShowMenu: true,
    keepAlive:true
  },
  name: '报表管理',
  redirect: '/index',
  children: [{
    path: '/reportsmgeIndex',
    component: reportIndex,
    name: '统计报表',
    meta: {
      right: ['统计报表'],
      isShowMenu: true,
      keepAlive:true
    },
  }]
};

export default reportsmgeRouter;